<template>
    <div @click="generatePdf">
        <md-button class="md-icon-button md-raised md-danger">
            <font-awesome-icon class="md-icon" :icon="['fa', generating ? 'sync-alt' : 'file-pdf']" :class="{'animate-spin': generating}" />
        </md-button>
        <md-tooltip v-if="!isFromClientArea" md-direction="top">PDF</md-tooltip>
    </div>
</template>

<script>
export default {
    name: "PlanButtonPdf",
    props: {
        data: Object,
        planId: Number,
        isFromClientArea: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            plan: {},
            generating: false
        }
    },
    methods: {
        async generatePdf() {
            this.generating = true
            let response
            if (this.isFromClientArea) {
                const localStorageData = JSON.parse(localStorage.getItem('client-area'))
                 response = await this.$store.dispatch('clientArea/generatePdf', {
                    documentId: this.plan.id ?? this.planId,
                     access_token: localStorageData.accessToken,
                     user_type: localStorageData.userType,
                })
            } else {
                response = await this.$store.dispatch('site_documents/generatePdf', {
                    documentId: this.plan.id ?? this.planId,
                })
            }
            let link = document.createElement('a')
            link.setAttribute('href', response.data)
            link.setAttribute('target', '_blank')
            link.click()
            this.generating = false
        }
    },
    mounted() {
        if(this.data) {
            this.plan = this.data
        }
    },
    watch: {
        data() {
            this.plan = this.data
        }
    }
}
</script>

<style scoped>

</style>
